import { ApolloError } from '@apollo/client';

import type { SubmitFormIntent } from '../constants';

export const DUPLICATE_HANGING_PROTOCOL_NAME_CODE = 'DUPLICATE_HANGING_PROTOCOL_NAME';

export const isUniqueNameError = (err: unknown): boolean => {
  if (!(err instanceof ApolloError)) return false;
  return err.graphQLErrors.some((e) => e.extensions?.code === DUPLICATE_HANGING_PROTOCOL_NAME_CODE);
};

export const getHangingProtocolErrorMessage = (
  err: unknown,
  mode: Nullable<SubmitFormIntent>
): string => {
  const action = mode ?? 'save';

  if (isUniqueNameError(err)) {
    return `Failed to ${action} hanging protocol. Hanging protocol must have a unique name.`;
  }

  const validationMessage = getHPValidationMessage(err);
  if (validationMessage != null) {
    return `Failed to ${action} hanging protocol. ${validationMessage}`;
  }

  return `Failed to ${action} hanging protocol.`;
};

/**
 * The backend's validation message for a rejected HP mutation, or null. Without it every rejection read as the same
 * generic failure, so a reader whose update could never succeed retried it for days (VX-5331).
 *
 * Only errors `toHPError` mapped qualify: it stamps `extensions.operation` and formats the DRF body into one readable
 * line. Server-side `HP_BACKEND_ERROR`s are excluded because their text describes the backend, not the reader's input.
 */
const getHPValidationMessage = (err: unknown): string | null => {
  if (!(err instanceof ApolloError)) return null;
  const validationError = err.graphQLErrors.find(
    (e) => e.extensions?.code === 'BAD_USER_INPUT' && e.extensions?.operation != null
  );
  return validationError?.message || null;
};
